export default __webpack_public_path__ + "static/media/lemonade-headline@3x.1fbc2af5.png";